import React from 'react';
const WidgetTitle = (props) => {
  return (
    <h5 {...props}>{props.children}</h5>
  )
}
export default WidgetTitle;
